export const style = {
  th: {
    fontSize: `14px`,
    fontWeight: 600,
    borderBottom: `1px solid #f4f4f4`,
    borderTop: 0,
    lineHeight: `1.4`,
    padding: `8px`
  },
  tr: {
    cursor: `pointer`,
    ':hover': {
      background: `#f5f5f5`
    }
  },
  td: {
    fontSize: `14px`,
    fontWeight: 400,
    padding: `8px`,
    lineHeight: `1.4`,
    borderTop: `1px solid #f4f4f4`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Settings/partials/SettingsEditor/style/table.js